import { createBrowserRouter, Navigate } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell.js";
import { DashboardPage } from "@/pages/DashboardPage.js";
import { LoginPage } from "@/pages/LoginPage.js";
import { ProtectedLayout } from "./ProtectedLayout.js";

export const routes = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: <ProtectedLayout />,
    children: [
      {
        element: <AppShell />,
        children: [
          { index: true, element: <Navigate to="/dashboard" replace /> },
          { path: "dashboard", element: <DashboardPage /> },
        ],
      },
    ],
  },
];

export const router = createBrowserRouter(routes);
